import { Box, Button, Modal } from '@palmetto/palmetto-components';

export const MoveStrandedAccountModal = ({
  isModalOpen,
  handleCloseModal,
  isAssigned,
  dataIsUpdating,
  updateFunction,
}: {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  isAssigned: boolean;
  dataIsUpdating: boolean;
  updateFunction: () => Promise<void>;
}) => {
  const title = isAssigned
    ? 'Remove Account from Untrancheable Asset Team'
    : 'Move Account to Untrancheable Asset Team';
  const confirmationText = (
    <Box>
      {isAssigned ? (
        <>Are you sure you want to remove this account from the Untrancheable Asset Team?</>
      ) : (
        <>Are you sure you want to move this account to the Untrancheable Asset Team?</>
      )}
    </Box>
  );

  return (
    <Modal ariaLabelledBy="titleBasic" isOpen={isModalOpen} onDismiss={handleCloseModal} maxWidth="5xl">
      <Modal.Header id="titleBasic" title={title} onDismiss={handleCloseModal} />
      <Modal.Body childGap="md" background="secondary">
        {confirmationText}
      </Modal.Body>
      <Modal.Footer justifyContent="space-between">
        <Button
          onClick={handleCloseModal}
          variant="secondary"
          tone="neutral"
          isDisabled={dataIsUpdating}
          isLoading={dataIsUpdating}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="shadow-xs"
          onClick={updateFunction}
          style={{ whiteSpace: 'nowrap' }}
          isDisabled={dataIsUpdating}
          isLoading={dataIsUpdating}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
